// app/translate/translate.pipe.ts

import { Pipe, PipeTransform } from '@angular/core';
import { TranslateServiceForm } from './translate.service'; // our translate service

@Pipe({name: 'translate'})
export class TranslatePipe implements PipeTransform {
    constructor(private _translate: TranslateServiceForm) { }
    transform(value: string, args: any[]): any {
        if (!value) return;
        return this._translate.instant(value, args);
    }
}


// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/translate/translate.pipe.ts